import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { Form, Modal, FormGroup } from "react-bootstrap";

import Button from "../../../../components/common/button/Button";
import AddFilterBox from "./AddFilterBox";
import styles from "./Filters.scss";

import { getInvoiceStatus } from "../../../../actions/invoice.actions";

import { getFilterFromRouteState } from "../../../../utils/parseQueries";

class Filters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: props.show || false
    };

    this.handleClose = this.handleClose.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
  }

  componentDidMount() {
    this.props.getInvoiceStatus();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.show !== nextProps.show) {
      this.setState({ show: nextProps.show });
    }
  }

  handleClose() {
    this.setState({ show: false }, this.props.onClose);
  }

  applyFilters() {
    this.handleClose();
  }

  render() {
    const { submitting, valid } = this.props;

    return (
      <Modal
        show={this.state.show}
        onHide={this.handleClose}
        dialogClassName={styles.modalContainer}
      >
        <Modal.Body className={styles.modalBody}>
          <Form onSubmit={this.props.handleSubmit}>
            <FormGroup>
              <div className={styles.title}>Filter Invoice Table</div>
              <div className={styles.dividerDouble} />
              <div className={styles.subtitle}>
                Find just what you’re looking for by creating filters for your
                current data set.
              </div>
              <div className={styles.filtersContainer}>
                <AddFilterBox
                  name="filters"
                  addText="Add Filter"
                  statusOptions={this.props.statusOptions}
                />
              </div>
            </FormGroup>

            <div className={styles.dividerDouble} />

            <div className={styles.CTAContainer}>
              <Button
                isPrimary
                type="submit"
                label="View Results"
                onClick={this.applyFilters}
                isDisabled={!valid || submitting}
              />
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

Filters = reduxForm({
  form: "invoicesTableFilters",
  enableReinitialize: true,
  destroyOnUnmount: true
})(Filters);

Filters = connect(
  state => {
    return {
      statusOptions: state.invoice.status,
      initialValues: getFilterFromRouteState(state, "filters")
    };
  },
  dispatch => {
    return {
      getInvoiceStatus: () => dispatch(getInvoiceStatus())
    };
  }
)(Filters);

export default Filters;



// WEBPACK FOOTER //
// ./src/routes/admin/invoices/components/Filters.js